import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import classnames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import get from 'lodash/get';
import map from 'lodash/map';
import isNull from 'lodash/isNull';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import AnalyticsAction from 'yoda-site-components/lib/actions/AnalyticsAction';
import StickyBetween from 'yoda-site-components/lib/components/StickyBetween/StickyBetween';
import ClientSideLoggerAction from 'yoda-site-components/lib/actions/ClientLoggerAction';
import { setLastCartVisitTime } from 'yoda-site-components/lib/helpers/Utils/activeCartLastCartVisitTime';
import {
    CHECKOUT,
    PAYMENT,
    REVIEW_PAGE_TITLE,
} from 'yoda-checkout-components/lib/common/LabelConstants';
import {
    X_COMMAND_CHECKOUT,
    PAYPAL_STRATEGY_TYPE_PAYPAL,
    ANALYTICS_ACTIONS_EXPEDITED_CHECKOUT,
    ANALYTICS_ACTIONS_EXPRESS_CHECKOUT,
    ANALYTICS_EXPEDITED_CHECKOUT_ELIGIBLE,
    ANALYTICS_EXPRESS_CHECKOUT_ELIGIBLE,
    ANALYTICS_PAGE_NAME_CHECKOUT_REVIEW,
    URL_CHECKOUT_PAGE,
    URL_CONFIRMATION_PAGE,
    CHECKOUT_ACCORDION_TITLE_SDPU,
    SHIPPING_GROUP_TITLE_SHIPPING,
    PAGE_TITLES_REVIEW_ORDER,
    REWARD_CATEGORY,
    REWARD_PROMO_FINANCE_CONFLICT,
    CURRENCY_US,
} from 'yoda-checkout-components/lib/common/Constants';
import CheckoutHeader from 'yoda-checkout-components/lib/components/CheckoutHeader/CheckoutHeader';
import Footer from 'yoda-checkout-components/lib/components/Footer/Footer';
import * as CheckoutAnalyticsAction from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import * as clearCouponAction from 'yoda-checkout-components/lib/actions/COAdjustmentAction';
import storeActions from 'yoda-site-components/lib/actions/OrderAction';
import {
    updateUserZipcode,
    getFormattedValue,
    startAccertify,
} from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import {
    isAgentLogged,
    isSentToAgencyFromCart,
} from 'yoda-core-components/lib/helpers/Utils/Utils';
import {
    scrollToElement,
    updateCartUID,
} from 'yoda-checkout-components/lib/helpers/Utils/ATCCommonUtils';
import LiveChat from 'yoda-checkout-components/lib/components/LiveChat/LiveChat';
import GenericOopsMessage from 'yoda-checkout-components/lib/components/GenericOopsMessage/GenericOopsMessage';
import DelaySpinner from 'yoda-checkout-components/lib/components/DelaySpinner/DelaySpinner';
import ShowRewardsPanel from 'yoda-checkout-components/lib/components/ShowRewardsPanel/ShowRewardsPanel';
import CouponsPanel from 'yoda-checkout-components/lib/components/Coupons/CouponsPanel';
import SessionTimeoutModal from 'yoda-checkout-components/lib/components/SessionTimeoutModal/SessionTimeoutModal';
import SerialCodeInputModal from 'yoda-checkout-components/lib/components/Coupons/SerialCodeInputModal/SerialCodeInputModal';
import CouponAppliedModal from 'yoda-checkout-components/lib/components/Coupons/CouponAppliedModal/CouponAppliedModal';
import OOSModal from 'yoda-checkout-components/lib/components/OOSModal/OOSModal';
import ServiceErrorModal from 'yoda-checkout-components/lib/components/ServiceErrorModal/ServiceErrorModal';
import withBoundaryError from 'yoda-checkout-components/lib/components/ErrorBoundary/ErrorBoundaryHOC';
import { CART_PAGE_URL } from 'yoda-site-components/lib/common/Constants';
import * as showGlobalLoaderAction from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import * as outOfStockActions from 'yoda-checkout-components/lib/actions/OutOfStockActions';
import * as orderSubmittableAction from 'yoda-checkout-components/lib/actions/OrderSubmittableAction';
import * as serviceErrorHandlerAction from 'yoda-checkout-components/lib/actions/ServiceErrorHandlerAction';
import {
    checkException,
    handleAuroraRedirection,
} from 'yoda-checkout-components/lib/helpers/ExceptionHandler';
import * as PlaceOrderActions from 'yoda-checkout-components/lib/actions/PlaceOrderActions';
import makeQuery, { stringifyQuery } from 'yoda-core-components/lib/navigation/query/makeQuery';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ShipAndPayPreShellLoader from 'yoda-checkout-components/lib/components/PreShellLoaders/ShipAndPayPreShellLoader/ShipAndPayPreShellLoader';
import OrderSummaryPreShellLoader from 'yoda-checkout-components/lib/components/PreShellLoaders/OrderSummaryPreShellLoader/OrderSummaryPreShellLoader';
import B2BVoucherHeader from 'yoda-site-components/lib/components/B2BVoucher/B2bVoucherHeader';
import PromotionalFinancing from '../../../components/PromotionalFinancing/PromotionalFinancingLazy';
// eslint-disable-next-line import/no-named-as-default
import PromoFinanceDecisionModal from '../../../components/PromoFinanceDecisionModal/PromoFinanceDecisionModal';
import * as GetCartDetailsAction from '../../../actions/GetCartDetailsAction';
import * as paymentActions from '../../../actions/PaymentAction';
import * as getStoreActions from '../../../actions/GetStoreAction';
import * as checkoutPageActions from '../../../actions/CheckoutPageActions';
// eslint-disable-next-line import/no-named-as-default
import ReviewAccordionWrapper from './components/ReviewAccordionWrapper/ReviewAccordionWrapper';
// eslint-disable-next-line import/no-named-as-default
import OrderSummary from '../../../components/OrderSummary/OrderSummary';
// eslint-disable-next-line import/no-named-as-default
import PaymentSection from './components/PaymentSection/PaymentSection';
// eslint-disable-next-line import/no-named-as-default
import SameDayPickupReviewSection from './components/SameDayPickupReviewSection/SameDayPickupReviewSection';
// eslint-disable-next-line import/no-named-as-default
import ShippingReviewSection from './components/ShippingReviewSection/ShippingReviewSection';
import * as newPaymentAction from '../../../actions/NewPaymentAction';
import * as newShippingAction from '../../../actions/NewShippingAction';
import * as orderInfoAction from '../../../actions/OrderInfoAction';
import * as styles from './ReviewPage.css';

const cx = classnames.bind(styles);
let isAnalyticsActionFired = false;
const section = 'REVIEW';

/* istanbul ignore next */
export class ReviewPage extends Component {
    static defaultProps = {
        actions: {},
        orderInfo: {},
        selectedStore: {},
        orderShippingGroupsInfo: [],
        location: {},
        orderCharges: [],
        orderPaymentInfo: [],
        payment: {},
        isSessionTimedOut: false,
        shipToStore: {},
        storeDetails: {},
        curbSideText: {},
        enableClickStreamLogs: false,
        messagesTexts: {},
        couponDisplayModal: {},
    };

    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func),
        orderInfo: PropTypes.objectOf(PropTypes.object),
        selectedStore: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        orderShippingGroupsInfo: PropTypes.arrayOf(
            PropTypes.oneOfType([PropTypes.object, PropTypes.string])
        ),
        location: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.object]),
        orderDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
        orderCharges: PropTypes.arrayOf(PropTypes.object),
        orderPaymentInfo: PropTypes.arrayOf(PropTypes.object),
        payment: PropTypes.arrayOf(PropTypes.object),
        showGlobalLoader: PropTypes.bool.isRequired,
        context: PropTypes.objectOf(PropTypes.object).isRequired,
        isSessionTimedOut: PropTypes.bool,
        mountOnServer: PropTypes.bool.isRequired,
        shipToStore: PropTypes.objectOf(PropTypes.object),
        storeDetails: PropTypes.objectOf(PropTypes.object),
        oosDetails: PropTypes.oneOfType(PropTypes.object).isRequired,
        curbSideText: PropTypes.objectOf(PropTypes.object),
        analyticsClickEvent: PropTypes.string.isRequired,
        enableClickStreamLogs: PropTypes.bool,
        messagesTexts: PropTypes.objectOf(PropTypes.object),
        couponDisplayModal: PropTypes.objectOf(PropTypes.object),
    };

    constructor() {
        super();
        this.state = {
            renderPromoModal: false,
            closePromoSuccessMsgClicked: false,
            sendingToAgency: false,
            isAgent: false,
        };
        this.isPageLoadSuccessActionFired = false;
        this.getAccordionList = this.getAccordionList.bind(this);
        this.getSameDayPickupReviewContent = this.getSameDayPickupReviewContent.bind(this);
        this.getShippingReviewContent = this.getShippingReviewContent.bind(this);
        this.onClosePromoSuccessMsg = this.onClosePromoSuccessMsg.bind(this);
        this.continueToCart = this.continueToCart.bind(this);
        this.removeOOSItems = this.removeOOSItems.bind(this);
        this.checkoutBlockRef = React.createRef();
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        const { enableClickStreamLogs, actions, mountOnServer, context, orderDetails } = this.props;
        actions.clearRenderFrom();
        actions.setMountOnServer(mountOnServer);
        if (!__SERVER__) {
            window.jcpDLjcp = {};
            scrollToElement();
            const fetchPromoOffers = LocalStorage.getData('fetchPromoOffers', true);
            this.setState({ renderPromoModal: !isNull(fetchPromoOffers) });
        }
        actions.setOrderSubmittable(true);

        /**
         * To add or update cookie 'DP_USER_DEFAULT_ADDRESS_ZIP' value based on shipping address zipcode.
         * To Add or Update UID Cookie
         */
        if (!__SERVER__) {
            actions.showGlobalLoader(false);
            const enableSingleDeliveryDateSTH = get(
                context.featureFlags,
                'enableSingleDeliveryDateSTH',
                true
            );
            enableSingleDeliveryDateSTH && updateUserZipcode(orderDetails);
            updateCartUID(orderDetails);
        }
        const { token } = makeQuery(this.props.location.search);
        if ((isEmpty(this.props.orderInfo) || !this.props.orderInfo.isPreLoadCall) && !token) {
            // Check if any order api call was already made in shipping or payment section
            // before redirecting to the review page.
            // pass page name to pass query value on API
            (mountOnServer || !__SERVER__) &&
                actions.getCartDetails({ includeServiceLevels: true, pageName: 'review' });
        }
        if (mountOnServer && !__SERVER__) {
            const exceptions = get(orderDetails, 'data.status.exceptions', []);
            /* istanbul ignore else */
            if (!isEmpty(exceptions)) {
                /* istanbul ignore next */
                let orderExceptionInfo = handleAuroraRedirection(
                    exceptions,
                    null,
                    true,
                    true,
                    false,
                    false,
                    enableClickStreamLogs
                );
                if (!orderExceptionInfo) {
                    orderExceptionInfo = checkException(
                        exceptions,
                        true,
                        true,
                        enableClickStreamLogs
                    );
                }
                orderExceptionInfo && actions.setOrderErrorMessage(orderExceptionInfo);
            }
            this.getPromoFinancingCall();
        }
    }

    componentDidMount() {
        const query = this.props.location ? makeQuery(this.props.location.search) : undefined;
        const prevUrl = TokenProvider.get('checkoutPrevUrl');
        /* istanbul ignore next */
        if (!__SERVER__ && query && query.token && URL_CONFIRMATION_PAGE !== prevUrl) {
            const payLoad = {
                xCommand: X_COMMAND_CHECKOUT,
                xStrategy: PAYPAL_STRATEGY_TYPE_PAYPAL,
                xClientSource: CHECKOUT,
            };
            this.props.actions.addPayPalPaymentType(payLoad);
        }
        const {
            orderInfo,
            actions,
            context: {
                featureFlags,
                preferences: { accertifyConfig = {} },
            },
        } = this.props;
        if (!__SERVER__ && featureFlags.enableAccertifyScriptLoad) {
            startAccertify(accertifyConfig, this.props.actions.logError, 'placeorder_review');
        }
        // DA ==> Trigger 'checkout review' pageload from componentDidMount when orderInfo.isPreLoadCall is true.
        // ** DO NOT REMOVE THIS CODE FROM HERE **
        if (!this.isPageLoadSuccessActionFired && orderInfo.isPreLoadCall) {
            this.isPageLoadSuccessActionFired = true;
            actions.pageLoadSuccessAnalyticsAction(ANALYTICS_PAGE_NAME_CHECKOUT_REVIEW);
        }
        const stsGroup = find(
            this.props.orderShippingGroupsInfo,
            (group) => group.type === 'STORE'
        );
        /* istanbul ignore else */
        if (
            !isEmpty(stsGroup) &&
            isEmpty(this.props.shipToStore) &&
            stsGroup.store &&
            stsGroup.store.id &&
            isEmpty(this.props.storeDetails[stsGroup.store.id])
        ) {
            actions.getStoreInfo(stsGroup.store.id);
        }
        window.addEventListener(
            'unload',
            /* istanbul ignore next */
            () => {
                setLastCartVisitTime();
            }
        );

        this.props.actions.hideNewCreditCardForm();
        this.props.actions.clearUserInputAddress();
        this.setRewardsPilotIndicator();
        LocalStorage.removeData('bnplSelected');

        /* B2B Voucher Portal code */
        /* istanbul ignore next */
        if (isSentToAgencyFromCart(this.props.context)) {
            this.setState({ sendingToAgency: true });
        }

        /* istanbul ignore next */
        if (isAgentLogged(this.props.b2bCookies)) {
            this.setState({ isAgent: true });
        }
    }

    // eslint-disable-next-line camelcase
    /* istanbul ignore next */
    componentDidUpdate(prevProps, nextProps) {
        const {
            location,
            payment,
            orderShippingGroupsInfo,
            shipToStore,
            storeDetails,
            actions,
        } = this.props;
        const { action = '' } = makeQuery(location?.search);
        if (this.props.isSessionTimedOut && this.props?.couponDisplayModal?.displayModal) {
            this.props.actions.clearCouponDisplayModal();
        }
        if (this.props.orderPaymentInfo !== nextProps?.orderPaymentInfo && !isEmpty(action)) {
            /* istanbul ignore else */
            if (action === 'isFromShipping' && this.shouldGoPayment(nextProps)) {
                if (get(payment, 'promoFinancingData.options.length', 0) > 0) {
                    this.props.actions.resetPromoFinancingData();
                }
                const checkoutURLConfig = {
                    pathname: URL_CHECKOUT_PAGE,
                    search: stringifyQuery({
                        action: 'Payment',
                    }),
                };
                getBrowserHistory().push(checkoutURLConfig);
            }
        }

        // DA ==> Trigger 'checkout review' pageload.
        // ** DO NOT REMOVE THIS CODE FROM HERE **
        if (
            !this.isPageLoadSuccessActionFired &&
            this.props?.orderDetails !== nextProps?.orderDetails
        ) {
            this.isPageLoadSuccessActionFired = true;
            this.props?.actions?.pageLoadSuccessAnalyticsAction(
                ANALYTICS_PAGE_NAME_CHECKOUT_REVIEW
            );
        }

        // DA => click event handler for Review Page
        /* istanbul ignore else */
        if (this.props.orderDetails && this.props.orderDetails.data) {
            const { analyticsAttributes } = this.props.orderDetails.data;
            const expressCheckout = find(analyticsAttributes, {
                type: ANALYTICS_EXPRESS_CHECKOUT_ELIGIBLE,
            });
            const expediteCheckout = find(analyticsAttributes, {
                type: ANALYTICS_EXPEDITED_CHECKOUT_ELIGIBLE,
            });

            // While landing on this page, fire either of the events only once => ExpressCheckout, expeditedCheckout
            /* istanbul ignore else */
            if (!isAnalyticsActionFired && expressCheckout && expressCheckout.value === 'true') {
                isAnalyticsActionFired = true;
                this.props?.actions?.clickEventAnalyticsAction(ANALYTICS_ACTIONS_EXPRESS_CHECKOUT);
            } else if (
                !isAnalyticsActionFired &&
                expediteCheckout &&
                expediteCheckout.value === 'true'
            ) {
                isAnalyticsActionFired = true;
                this.props?.actions?.clickEventAnalyticsAction(
                    ANALYTICS_ACTIONS_EXPEDITED_CHECKOUT
                );
            }
        }
        /* istanbul ignore else */
        if (orderShippingGroupsInfo !== nextProps?.orderShippingGroupsInfo) {
            const stsGroup = find(orderShippingGroupsInfo, (group) => group.type === 'STORE');
            /* istanbul ignore else */
            if (
                !isEmpty(stsGroup) &&
                isEmpty(shipToStore) &&
                isEmpty(storeDetails[stsGroup.store.id])
            ) {
                actions?.getStoreInfo(stsGroup.store.id);
            }
        }
        this.getPromoFinancingCall();

        /* istanbul ignore next */
        if (!isEmpty(this.props.analyticsClickEvent) && !isEmpty(this.props.orderDetails)) {
            this.props.actions.clickEventAnalyticsAction(this.props.analyticsClickEvent);
            // Flush previously stored analytics action from store
            this.props?.actions?.updateAnalyticsClickAction({});
        }
    }

    onClosePromoSuccessMsg() {
        this.setState({
            closePromoSuccessMsgClicked: true,
        });
    }

    onClose = () => {
        document.body.style.overflow = 'scroll';
        document.body.style.position = 'static';
        this.setState({ isModalOpen: false });
    };

    getPromoFinancingCall() {
        /* istanbul ignore next */
        const fetchPromoOffers = LocalStorage.getData('fetchPromoOffers', true);
        /* istanbul ignore next */
        if (fetchPromoOffers && !isEmpty(this.props.orderPaymentInfo)) {
            const paymentMethod = find(this.props.orderPaymentInfo, {
                paymentMethod: 'creditCard',
            });
            let isFinancing = get(this.props.orderDetails, 'data.billing.creditCards.financing');
            if (!isFinancing) {
                isFinancing = get(
                    this.props.orderDetails,
                    'data.billing.creditCards.cards[0].financing'
                );
            }
            if (paymentMethod && isFinancing) {
                const payload = {
                    cardId: paymentMethod.id,
                };
                this.props.actions.getPromoFinancingOffers(payload);
            }
            LocalStorage.removeData('fetchPromoOffers', true);
        }
    }

    getAccordionList() {
        const accordionList = [];
        const paymentInfo = {};
        paymentInfo.title = PAYMENT;
        paymentInfo.container = (
            <PaymentSection
                messagesTexts={this.props.messagesTexts}
                contactMethods={this.props.orderDetails?.data?.contact?.methods || []}
            />
        );

        const sameDayPickupReview = this.getSameDayPickupReviewContent();
        if (sameDayPickupReview) {
            accordionList.push({
                title: CHECKOUT_ACCORDION_TITLE_SDPU,
                container: sameDayPickupReview,
            });
        }

        const shippingReviewContent = this.getShippingReviewContent();
        if (shippingReviewContent) {
            accordionList.push({
                title: SHIPPING_GROUP_TITLE_SHIPPING,
                container: shippingReviewContent,
            });
        }

        if (!this.state.sendingToAgency) {
            accordionList.push(paymentInfo);
        }
        return accordionList;
    }

    /* istanbul ignore next */
    getShippingReviewContent() {
        const { orderShippingGroupsInfo, payment } = this.props;
        const shippingGroupInfo = find(
            orderShippingGroupsInfo,
            (group) => group.type === 'HOME' || group.type === 'STORE'
        );
        const { rewardOrPromoFinanceData } = payment;
        const showPromoSuccess =
            !isEmpty(rewardOrPromoFinanceData) &&
            (rewardOrPromoFinanceData.isSpecialFinancingSelected ||
                rewardOrPromoFinanceData.isRewardRemoved);
        const rewardOrPromoFinanceMessage = {
            rewardOrPromoFinanceData,
            showPromoSuccess,
            closePromoSuccessMsgClicked: this.state.closePromoSuccessMsgClicked,
            onClosePromoSuccessMsg: this.onClosePromoSuccessMsg,
        };
        if (rewardOrPromoFinanceData && rewardOrPromoFinanceData.rewardPercentage) {
            rewardOrPromoFinanceData.rewardPercentage = getFormattedValue(
                rewardOrPromoFinanceData.rewardPercentage
            );
        }
        /* istanbul ignore next */
        if (!isEmpty(shippingGroupInfo)) {
            return (
                <div className={cx('shippingSectionContainer')}>
                    <ShippingReviewSection
                        shippingGroupInfo={shippingGroupInfo}
                        orderCharges={this.props.orderCharges}
                        rewardOrPromoFinanceMessage={rewardOrPromoFinanceMessage}
                    />
                </div>
            );
        }
        return null;
    }

    getSameDayPickupReviewContent() {
        const { orderShippingGroupsInfo, selectedStore, curbSideText } = this.props;
        const isCurbSideAvailable = get(selectedStore, 'storeDetails.services', []).includes(
            curbSideText.curbSidePickup
        );
        let bopisItems = [];
        if (
            orderShippingGroupsInfo &&
            orderShippingGroupsInfo.length > 0 &&
            orderShippingGroupsInfo[0].type === 'BOPIS' &&
            orderShippingGroupsInfo[0].bagItems.length > 0
        ) {
            if (
                (isEmpty(selectedStore) || isEmpty(selectedStore.storeDetails)) &&
                orderShippingGroupsInfo[0].store
            ) {
                this.props.actions.getStoreByStoreId({
                    storeId: orderShippingGroupsInfo[0].store.id,
                });
            }
            bopisItems = orderShippingGroupsInfo[0].bagItems;
            const alternatePickupInfo = orderShippingGroupsInfo[0].pickup;
            const { pickupDateMessage } = orderShippingGroupsInfo[0];
            return (
                <div>
                    <SameDayPickupReviewSection
                        bopisItems={bopisItems}
                        selectedStore={selectedStore}
                        alternatePickupInfo={alternatePickupInfo}
                        pickupDateMessage={pickupDateMessage}
                        isCurbSideAvailable={isCurbSideAvailable}
                        curbSideText={curbSideText}
                    />
                </div>
            );
        }
        return null;
    }

    getRewardSelected = (orderDetails) => {
        const adjustments = get(orderDetails, 'data.adjustments', []);
        const reward = find(adjustments, { rewardCategory: REWARD_CATEGORY });
        return !isEmpty(reward) ? reward : {};
    };

    continueToCart = () => {
        window.location.replace(CART_PAGE_URL);
    };

    removeOOSItems = () => {
        // Making the initiate checkout call to remove the OOS items and the
        // empty delivery groups if any have been associated with the OOS item.
        this.props.actions.getCartDetails({ initiateCheckout: true, xDeleteOOSItems: true });
        this.props.actions.showGlobalLoader(true);
        this.props.actions.resetOosDetails();
    };

    shouldGoPayment = ({ orderPaymentInfo }) => {
        let goPayment = false;
        map(orderPaymentInfo, (payment) => {
            if (payment.status && payment.status.toUpperCase() === 'UNVERIFIED') {
                goPayment = true;
            } else if (payment.type && payment.type.toUpperCase() === 'GIFTCARD') {
                goPayment = true;
            }
        });

        return goPayment;
    };

    checkRewardPromoFinanceConflict = (orderDetails) => {
        const exceptions = get(orderDetails, 'data.status.exceptions', []);
        const rewardPromoFinanceConflict = !isEmpty(
            find(exceptions, { errorCode: REWARD_PROMO_FINANCE_CONFLICT })
        );
        return rewardPromoFinanceConflict;
    };

    renderSlidePanel = () => {
        return (
            <section>
                <SerialCodeInputModal pageInfo="checkout" />
                <ShowRewardsPanel pageInfo="checkout" checkoutFlow />
                <CouponsPanel pageInfo="checkout" panelTitle="Coupons" />
            </section>
        );
    };

    renderDiscountAppliedModal = () => {
        const { payment } = this.props;
        const { rewardOrPromoFinanceData } = payment;
        const rewardSelected = this.getRewardSelected(this.props.orderDetails);
        const isSpecialDiscountApplied =
            rewardOrPromoFinanceData && rewardOrPromoFinanceData.specialDiscountApplied;
        const showModal =
            this.state.isModalOpen !== undefined
                ? this.state.isModalOpen
                : isSpecialDiscountApplied;
        return showModal ? (
            <CouponAppliedModal
                title="Discount Applied"
                savings={rewardSelected && rewardSelected.amount}
                currency={CURRENCY_US}
                onClose={this.onClose}
                deviceType={this.props.context.deviceType}
                financingOption
            />
        ) : (
            ''
        );
    };

    renderOOSModal = () => {
        const { oosDetails } = this.props;
        const oosItemProducts = get(oosDetails, 'discontinuedOOSDetails.oosItemProducts', []);
        const discontinuedItemProducts = get(
            oosDetails,
            'discontinuedOOSDetails.discontinuedItemProducts',
            []
        );
        const products = [...oosItemProducts, ...discontinuedItemProducts];
        if (!oosDetails.isShowModal) {
            return null;
        }
        const isShowCheckout =
            !oosDetails.isAllItemsOos &&
            !oosDetails.isAllItemsDiscontinued &&
            !oosDetails.isAllItemsDiscontinuedAndOOS;
        return (
            <OOSModal
                products={products}
                isShowModal={oosDetails.isShowModal}
                isShowCheckout={isShowCheckout}
                onClose={this.continueToCart}
                onContinue={this.continueToCart}
                onCheckout={this.removeOOSItems}
            />
        );
    };

    setRewardsPilotIndicator = () => {
        const rewardsPilot = Cookies.load('eligibleForRewardsPilot') || false;
        if (rewardsPilot) {
            this.setState({ rewardsPilotIndicator: true });
        }
    };

    render() {
        const {
            showGlobalLoader,
            payment,
            orderInfo,
            orderDetails,
            context,
            isSessionTimedOut,
        } = this.props;
        if (isEmpty(orderInfo) && isSessionTimedOut) {
            return (
                <div>
                    <SessionTimeoutModal isShowModal={isSessionTimedOut} />
                </div>
            );
        }
        const accordionList = this.getAccordionList();
        const showPlaceOrderButton = true;
        const activeLoaderClass = showGlobalLoader ? 'disableUserActions' : '';
        const isPromoFinancingSelected =
            orderInfo && orderInfo.financing && orderInfo.financing.selected;
        const isDesktop = context.deviceType && context.deviceType.isDesktop;
        const showPromoFinancingModal =
            this.state.renderPromoModal && get(payment, 'promoFinancingData.options.length', 0) > 0;
        const showPromoFinancingDecisionModal = this.checkRewardPromoFinanceConflict(orderDetails);
        const preferences = get(this.props, 'context.preferences', {});
        const { rewardsPilotIndicator } = this.state;

        return (
            <section
                className={`${cx('tailwindGrid')} ${dt([
                    'bg-white',
                    'relative',
                    'overflow-hidden',
                ])}`}
                id={rewardsPilotIndicator ? 'eligible-for-rewards-pilot' : ''}
                data-automation-id="at-review-main-wrapper"
            >
                <Helmet title={PAGE_TITLES_REVIEW_ORDER} />
                {isAgentLogged(this.props.b2bCookies) && <B2BVoucherHeader />}
                <CheckoutHeader
                    items={orderInfo.itemsCount}
                    deviceType={context.deviceType}
                    feedbackToken={preferences.feedbackToken}
                />
                <GenericOopsMessage />

                <section
                    className={`${cx('checkoutBlock')} ${dt([
                        !isDesktop && 'cursor-pointer',
                        'bg-white',
                        'my-6',
                        'mx-auto',
                        'px-6',
                        'max-w-[1440px]',
                        'tailwindGrid',
                        'h-full',
                        'text-black',
                        'mb-6',
                    ])}`}
                    data-automation-id="at-review-main-block"
                    ref={this.checkoutBlockRef}
                >
                    {this.renderOOSModal()}
                    <ServiceErrorModal sectionName="placeOrder" />
                    <SessionTimeoutModal isShowModal={isSessionTimedOut} />
                    {(isEmpty(orderInfo) || accordionList.length <= 0) && (
                        <div
                            className={dt([
                                'relative',
                                'smMd:py-0',
                                'flex',
                                'justify-between',
                                'smMd:flex-wrap',
                            ])}
                        >
                            <section className={cx('sm12', 'md12', 'lg7', 'xl7')}>
                                <ShipAndPayPreShellLoader />
                            </section>
                            <section
                                className={cx(
                                    'hiddenSm',
                                    'hiddenTwMd',
                                    'lg4',
                                    'xl4',
                                    'orderSummaryWrapper'
                                )}
                            >
                                <OrderSummaryPreShellLoader />
                            </section>
                            <section className={cx('sm12', 'md12', 'visibleSmMd')}>
                                <OrderSummaryPreShellLoader />
                            </section>
                        </div>
                    )}
                    {!isEmpty(orderInfo) && (
                        <>
                            <article>
                                {activeLoaderClass && <DelaySpinner />}
                                <section className={`${cx('sm12', 'md7')} ${dt(['!p-0'])}`}>
                                    <section
                                        className={dt([
                                            'text-2xlarge',
                                            'leading-6',
                                            'font-open-sans-bold',
                                            'text-black',
                                            'pb-4',
                                        ])}
                                        data-automation-id="at-review-page-title"
                                    >
                                        {REVIEW_PAGE_TITLE}
                                    </section>
                                </section>
                                <section
                                    className={`${cx(activeLoaderClass)}  ${dt([
                                        'relative',
                                        'smMd:py-0',
                                        'flex',
                                        'justify-between',
                                        'smMd:flex-wrap',
                                    ])}`}
                                    data-automation-id="at-review-content-wrapper"
                                >
                                    <section
                                        className={`${cx('sm12', 'md12', 'lg7', 'xl7')} ${dt([
                                            '!p-0',
                                        ])}`}
                                    >
                                        <section className={cx('newFulfilmentOptions')}>
                                            <ReviewAccordionWrapper accordionList={accordionList} />
                                        </section>
                                    </section>
                                    <section
                                        className={`${cx(
                                            'hiddenSm',
                                            'hiddenTwMd',
                                            'lg4',
                                            'xl4',
                                            'orderSummaryWrapper'
                                        )} ${dt([
                                            'sm:!p-0',
                                            'mdOnly:h-full',
                                            'mdOnly:absolute',
                                            'mdOnly:bg-white',
                                        ])}`}
                                        data-automation-id="at-ordersummarywrapper-large"
                                    >
                                        <StickyBetween stickyParentBlock={this.checkoutBlockRef}>
                                            <div
                                                className={`${cx('orderSummaryUI')} ${dt([
                                                    '!p-4',
                                                    'border',
                                                    'border-solid',
                                                    'border-gray-15',
                                                    'rounded-lg',
                                                    '!m-0',
                                                ])}`}
                                            >
                                                <div className={dt(['!m-0'])}>
                                                    <OrderSummary
                                                        showPlaceOrderButton={showPlaceOrderButton}
                                                        isShowCouponPricing
                                                        submitForApproval={
                                                            this.state.sendingToAgency
                                                        }
                                                        isAgentLogged={this.state.isAgent}
                                                    />
                                                </div>
                                            </div>
                                        </StickyBetween>
                                    </section>
                                    <section
                                        className={`${cx('sm12', 'md12', 'visibleSmMd')} ${dt([
                                            'mdOnly:bg-white',
                                            '!p-0',
                                            'mt-2',
                                        ])}`}
                                        data-automation-id="at-ordersummarywrapper-small"
                                    >
                                        <div className={cx('horizontalLine')} />
                                        <div
                                            className={`${cx('orderSummaryUI')} ${dt([
                                                '!p-4',
                                                'border',
                                                'border-solid',
                                                'border-gray-15',
                                                'rounded-lg',
                                                '!m-0',
                                            ])}`}
                                        >
                                            <OrderSummary
                                                showPlaceOrderButton={showPlaceOrderButton}
                                                isShowCouponPricing
                                            />
                                        </div>
                                    </section>
                                </section>
                            </article>
                            <LiveChat />
                        </>
                    )}
                </section>
                {/* Below will show options to select promo finance for express users */}
                {showPromoFinancingModal ? (
                    <PromotionalFinancing
                        openModal={showPromoFinancingModal}
                        offers={payment.promoFinancingData.options}
                        eConsentText={payment.promoFinancingData.econsentText}
                        isOfferSelected={isPromoFinancingSelected}
                    />
                ) : null}
                {/* Below will decision Modal to select either promof inance
                    or special discount if user has availed both */}
                {showPromoFinancingDecisionModal ? (
                    <PromoFinanceDecisionModal openModal={showPromoFinancingDecisionModal} />
                ) : null}
                {this.renderDiscountAppliedModal()}
                {!isEmpty(this.props.orderInfo) && (
                    <Footer
                        isDesktop={isDesktop}
                        phoneNumber={preferences.jcpHelpPhoneNumber}
                        context={context}
                    />
                )}
                {!__SERVER__ && this.renderSlidePanel()}
            </section>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        orderInfo,
        orderShippingGroupsInfo,
        selectedStore,
        orderDetails,
        orderCharges,
        orderPaymentInfo,
        payment,
        showGlobalLoader,
        context,
        session,
        shipToStore,
        storeDetails,
        oosDetails,
        checkoutPage,
        couponDisplayModal,
        analyticsClickEvent,
    } = state;
    const mountOnServer =
        (checkoutPage && checkoutPage.mountOnServer) ||
        (get(state, 'context.featureFlags.enableCheckoutServerSideRendering', true) &&
            get(state, 'context.headers.cookies.disabledCheckoutSSR', false) !== 'true');
    const enableClickStreamLogs = get(state, 'context.featureFlags.enableClickStreamLogs', false);
    const curbSideText = get(state, 'context.messagesTexts.curbSideText', {});
    const messagesTexts = get(state, 'context.messagesTexts', {});
    const b2bCookies = get(state, 'context.headers.cookies', {});
    return {
        orderInfo,
        orderShippingGroupsInfo,
        selectedStore,
        orderDetails,
        orderCharges,
        orderPaymentInfo,
        payment,
        showGlobalLoader,
        context,
        isSessionTimedOut: session.isSessionTimedOut,
        shipToStore,
        storeDetails,
        oosDetails,
        mountOnServer,
        curbSideText,
        analyticsClickEvent,
        couponDisplayModal,
        enableClickStreamLogs,
        messagesTexts,
        b2bCookies,
    };
};
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...GetCartDetailsAction,
            ...paymentActions,
            ...CheckoutAnalyticsAction,
            ...storeActions,
            ...getStoreActions,
            ...outOfStockActions,
            ...showGlobalLoaderAction,
            ...orderSubmittableAction,
            ...checkoutPageActions,
            ...serviceErrorHandlerAction,
            ...clearCouponAction,
            ...PlaceOrderActions,
            ...newPaymentAction,
            ...newShippingAction,
            ...orderInfoAction,
            ...AnalyticsAction,
            ...ClientSideLoggerAction,
        },
        dispatch
    ),
});
export default withBoundaryError(connect(mapStateToProps, mapDispatchToProps)(ReviewPage), section);
